import axios from "axios";
import { config } from "../config";
const TranslateToTamil = async (inputText) => {
  inputText = inputText.toLowerCase();
  if (inputText && containsOnlyEnglishLetters(inputText)) {
    const localData = await localStorage.getItem("tamilwords");
    if (!localData || !CheckLocalData(localData, inputText)) {
      console.log("called api");
      const url = "https://translator.ecapps.in/translate";
      let res = await axios.post(url, 
        {
          text: inputText,
          source: "en",
          target: "ta",
        },
        { 
          headers: { "Content-Type": "application/json" } 
        }
      );
      let translation = res.data.translated;
      const setLocal = {
        [inputText]: translation,
      };
      if (!localData) {
        localStorage.setItem("tamilwords", JSON.stringify(setLocal));
      } else {
        const prevData = JSON.parse(localData);
        const mergeData = { ...prevData, ...setLocal };
        localStorage.setItem("tamilwords", JSON.stringify(mergeData));
      }
      return translation;
    } else {
      console.log("result from local");
      return CheckLocalData(localData, inputText);
    }
  }
};

const CheckLocalData = (data, key) => {
  if (!data) return null;
  const values = JSON.parse(data);
  if (values[key]) {
    return values[key];
  } else {
    return null;
  }
};
function containsOnlyEnglishLetters(statement) {
  // Regular expression to match any single English letter (case-insensitive)
  const regex = /[a-zA-Z]/;
  // Test the statement against the regular expression
  return regex.test(statement);
}
export default TranslateToTamil;
